import React from "react";
import PropTypes from "prop-types";

const AdminWarnings = ({
  show,
  conflict,
  conflictShiftTimes,
  managementRequestOverMaxWeeklyHours,
  managementRequestOverMaxDailyHours,
  maxWeeklyHours,
  maxDailyHours
}) =>
  show ? (
    <p className="pink-text">
      {conflict ? (
        <span className="pink-text">
          Warning: Employee is already scheduled to work from{" "}
          {conflictShiftTimes}
        </span>
      ) : null}

      {managementRequestOverMaxWeeklyHours ? (
        <span>
          {conflict && <br />}
          Warning: {maxWeeklyHours} max weekly hours exceeded
        </span>
      ) : null}

      {managementRequestOverMaxDailyHours ? (
        <span>
          {(conflict || managementRequestOverMaxWeeklyHours) && <br />}
          Warning: {maxDailyHours} max daily hours exceeded
        </span>
      ) : null}
    </p>
  ) : null;

AdminWarnings.propTypes = {
  show: PropTypes.bool,
  conflict: PropTypes.bool,
  conflictShiftTimes: PropTypes.string,
  managementRequestOverMaxWeeklyHours: PropTypes.bool,
  maxWeeklyHours: PropTypes.number,
  managementRequestOverMaxDailyHours: PropTypes.bool,
  maxDailyHours: PropTypes.number
};

AdminWarnings.defaultProps = {
  show: false
};

export default AdminWarnings;
